import { z } from 'zod';
// Per-model market-field → model-target mapping config (market-defaults-application
// Phase 1; ADR 0005). The agents apply_market_defaults tool's factory loader reads a
// `market-aliases.json` sidecar per model and parses it with `marketAliasMapSchema`.
//
// Phase 1 EXERCISES only the scalar-string target arm + `null` + the `passthrough`
// transform. The `{table, column}` target arm + `multiply_unit_count` transform are
// AUTHORED-BUT-DORMANT — Phase 2 (transforms) + Phase 3 (table-write) exercise them.
/** Declared transform vocabulary (pure unit adapters, spec §2). Additive arm = additive change. */
export const marketAliasTransformSchema = z.enum([
    'passthrough',
    'multiply_unit_count',
]);
/** A table-cell target: addresses a column on a named table input. DORMANT in Phase 1. */
export const marketAliasTableTargetSchema = z
    .object({
    table: z.string().min(1),
    column: z.string().min(1),
})
    .strict();
/**
 * A market field's resolution target:
 *   - a scalar input name (string) — EXERCISED Phase 1,
 *   - a `{table, column}` table-cell target — DORMANT (Phase 3),
 *   - `null` — intentionally no target (explicit skip).
 */
export const marketAliasTargetSchema = z.union([
    z.string().min(1),
    marketAliasTableTargetSchema,
    z.null(),
]);
/** One mapping entry. `transform` defaults to `passthrough` when omitted. */
export const marketAliasEntrySchema = z
    .object({
    marketField: z.string().min(1),
    target: marketAliasTargetSchema,
    transform: marketAliasTransformSchema.optional(),
})
    .strict();
/** The per-model sidecar shape: an array of entries (mirrors `z.array(disambiguationRuleSchema)`). */
export const marketAliasMapSchema = z.array(marketAliasEntrySchema);
